import { all, put, fork, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
// import { AuthorizedGet, AuthorizedPost } from '@iso/lib/helpers/resApiRequestorAuth';
import { encryptedGet, encryptedPost } from '../../library/helpers/resApiEncryptedRequestor';
import {
    clearWebStoreId,
    getWebStoreId,
    clearTransactionDetails,
    getTransactionDetails,

} from '@iso/lib/helpers/utility';
import { pushDataToApp } from '@iso/lib/helpers/mobileAppCommKit';

export function* fetchStoreProducts() {
    yield takeEvery('FETCH_STORE_PRODUCTS', function* ({ payload }) {
        const state = yield select();
        const stateTransactionDetails = state.Store.transactionDetails;
        try {
            yield put({
                type: actions.FETCHING_STORE_PRODUCTS,
            });
            const apiResult = yield fetchWebStoreProducts(payload);
            if (apiResult.status === 200 || apiResult.status === 201) {
                if (apiResult.data.success) {
                    const webStoreId = getWebStoreId().get('webStoreId');
                    const parsedWebStoreId = webStoreId && webStoreId !== 'null' && webStoreId !== undefined ? JSON.parse(webStoreId) : '';
                    const transactionDetails = getTransactionDetails().get('transactionDetails');
                    const inventoryItem = apiResult.data.data.inventory;
                    const newInventory = inventoryItem.filter((el) => {
                        return 'Available' === el.statusInfo.label; // Remain all available products
                    })
                    apiResult.data.data.inventory = newInventory;
                    yield put({
                        type: actions.FETCHED_STORE_PRODUCTS,
                        data: apiResult.data.data,
                        webStoreId: parsedWebStoreId ? parsedWebStoreId !== payload ? JSON.stringify(payload) : webStoreId : JSON.stringify(payload),
                        transactionDetails: parsedWebStoreId ? parsedWebStoreId !== payload ? JSON.stringify(stateTransactionDetails) : transactionDetails : JSON.stringify(stateTransactionDetails),
                    });
                } else {
                    yield put({
                        type: actions.FETCH_STORE_PRODUCTS_FAILED,
                        message: apiResult.data.message,
                    });
                }
            }
        } catch (error) {
            yield put({
                type: actions.FETCH_STORE_PRODUCTS_FAILED,
                message: 'Failed to load products.'
            });
        }
    });
}
export function* checkoutCart() {
    yield takeEvery('SUBMIT_TRX', function* ({payload}) {
        try {
            yield put({
                type: actions.SUBMITTING_TRX
            });
            const apiResult = yield submitTempTransaction(payload);
            const result = apiResult.data;
            if (result.success) {
                yield clearWebStoreId();
                yield clearTransactionDetails();
                yield put({
                    type: actions.SUBMITTED_TRX,
                    payload: result.data,
                });
            } else {
                yield put({
                    type: actions.SUBMIT_TRX_FAILED,
                    message: result.message,
                });
            }
        } catch (error) {
            yield put({
                type: actions.SUBMIT_TRX_FAILED,
                message: 'Failed to checkout cart, please try again later.',
            });
        }
    });
}
export function* fetchWebStore() {
    yield takeEvery('FETCH_STORE_DATA', function* (payload) {
      try {
        yield put({
            type: actions.FETCHING_STORE_DATA,
          });
        const apiResult = yield fetchWebStoreSocMed(payload.payload);
        const result = apiResult.data;
        if (result.success) {
          yield put({
            type: actions.FETCHED_STORE_DATA,
            result: result.data,
          });
        } else {
          yield put({
            type: actions.FETCH_STORE_DATA_FAILED,
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_STORE_DATA_FAILED,
        });
      }
    });
  }
  
export function* addToCart() {
    yield takeEvery('ADD_TO_CART', function* ({ payload }) {
        yield put({
            type: actions.ADDED_TO_CART,
            transactionDetails: JSON.stringify(payload.transactionDetails),
            transactionProductsHolder: JSON.stringify(payload.transactionProductsHolder),
        });
    });
}
export function* addedToCart() {
    yield takeEvery(actions.ADDED_TO_CART, function* (payload) {
        yield localStorage.setItem('transactionDetails', payload.transactionDetails);
        pushDataToApp('transactionDetails', payload.transactionDetails);
    });
}
export function* fetchedStoreProducts() {
    yield takeEvery(actions.FETCHED_STORE_PRODUCTS, function* (payload) {
        yield localStorage.setItem('webStoreId', payload.webStoreId);
        yield localStorage.setItem('transactionDetails', payload.transactionDetails);
        pushDataToApp('webStoreId', payload.webStoreId);
        pushDataToApp('transactionDetails', payload.transactionDetails);
    });
}
function fetchWebStoreProducts(id) {
    // return AuthorizedGet(`webstores/get/web_products/${id}`);
    return encryptedGet(`webstores/get_encrypted/web_products/${id}`);
}
function fetchWebStoreSocMed(id) {
    // return AuthorizedGet(`webstores/get/webstore_data/store_id/${id}`);
    return encryptedGet(`webstores/get_encrypted/webstore_data/store_id/${id}`);
}
function submitTempTransaction(payload) {
    // return AuthorizedPost(`temptransactions`, payload);
    return encryptedPost(`temptransactions/create_encrypted`, payload);
}
export default function* rootSaga() {
    yield all([
        fork(fetchStoreProducts),
        fork(fetchedStoreProducts),
        fork(addToCart),
        fork(addedToCart),
        fork(checkoutCart),
        fork(fetchWebStore),
    ]);
}